import type { TFunction } from 'i18next';
import { formatCurrency } from '@/lib/format';

/** The two figures a line shows, whatever document it is on. */
interface LineFigures {
  quantity: number | string;
  unitPrice: number | string;
  hourly: boolean;
}

/**
 * A line's quantity as a screen shows it (M2-33): "2.5 hrs" for a line from an
 * hourly labor item, the bare number otherwise. `hourly` is the API's answer,
 * read through the price-book reference — never guessed from the tax category,
 * which a flat-rate service shares.
 */
export function quantityText(line: LineFigures, t: TFunction): string {
  const quantity = Number(line.quantity);
  return line.hourly ? t('lines.hours', { count: quantity, hours: quantity }) : String(quantity);
}

/** A line's unit price: "$95.00/hr" for hourly labor, the plain amount otherwise. */
export function unitPriceText(line: LineFigures, t: TFunction): string {
  const amount = formatCurrency(Number(line.unitPrice));
  return line.hourly ? t('lines.perHour', { amount }) : amount;
}
